import axios from "axios";
import api from "@/api";
import router from "@/router";

const state = {
  currentUser: null,
  userBalance: null,
  userMainCompany: null,
  userCompanies: {},
  userRelations: null,
  userDeals: null,
  userLimitCompanies: null,
  isAuth: false,
  userID: null,
  userRole: null,
  error: null,
  token: null,
  showTerms: false,
  showSystemCurator: false,
  unseenPromos: 0,
  loading: {
    general: false,
    balance: false,
    deals: false,
    limitCurators: false,
    limitCompanies: false,
    companies: true,
    relations: false
  }
};

const getters = {
  GET_CURRENT_USER(state) {
    return state.currentUser;
  },
  GET_USER_BALANCE(state) {
    return state.userBalance;
  },
  GET_USER_COMPANIES(state) {
    return state.userCompanies;
  },
  GET_USER_MAIN_COMPANY(state) {
    return state.userMainCompany;
  },
  GET_USER_RELATIONS(state) {
    return state.userRelations;
  },
  GET_USER_DEALS(state) {
    return state.userDeals;
  },
  GET_USER_LIMIT_COMPANIES(state) {
    return state.userLimitCompanies;
  },
  GET_IS_AUTH(state) {
    return state.isAuth;
  },
  GET_USER_ID(state) {
    return state.userID;
  },
  GET_USER_ROLE(state) {
    return state.userRole;
  },
  GET_ERROR(state) {
    return state.error;
  },
  GET_SHOW_TERMS(state) {
    return state.showTerms;
  },
  GET_SHOW_SYSTEM_CURATOR(state) {
    return state.showSystemCurator;
  },
  GET_UNSEEN_PROMOS(state) {
    return state.unseenPromos
  },
};

const mutations = {
  SET_CURRENT_USER(state, payload) {
    state.currentUser = payload;
  },
  SET_USER_BALANCE(state, payload) {
    state.userBalance = payload;
  },
  SET_USER_COMPANIES(state, { page, data }) {
    state.userCompanies = {
      ...state.userCompanies,
      [page]: data
    };
  },
  SET_USER_MAIN_COMPANY(state, payload) {
    state.userMainCompany = payload;
  },
  SET_USER_RELATIONS(state, payload) {
    state.userRelations = payload;
  },
  SET_USER_DEALS(state, payload) {
    state.userDeals = payload;
  },
  SET_USER_LIMIT_COMPANIES(state, payload) {
    state.userLimitCompanies = payload;
  },
  SET_IS_AUTH(state, payload) {
    localStorage.setItem("auth", JSON.stringify(payload));
    state.isAuth = JSON.parse(localStorage.getItem("auth"));
  },
  SET_USER_ID(state, payload) {
    // localStorage.setItem("userID", JSON.stringify(payload));
    state.userID = payload;
  },
  SET_USER_ROLE(state, payload) {
    localStorage.setItem("userRole", JSON.stringify(payload));
    state.userRole = JSON.parse(localStorage.getItem("userRole"));
  },
  SET_ERROR(state, payload) {
    state.error = payload;
  },
  SET_TOKEN(state, token) {
    if (!token) {
      token = null;
    }
    state.token = token;
    if (token !== null) {
      localStorage.setItem("token", token);
      axios.defaults.headers.common["Access-Token"] = token;
    } else {
      localStorage.removeItem("token");
      axios.defaults.headers.common["Access-Token"] = "";
    }
  },
  SET_SHOW_TERMS(state, payload) {
    state.showTerms = payload;
  },
  SET_SHOW_SYSTEM_CURATOR(state, payload) {
    state.showSystemCurator = payload;
  },
  SET_UNSEEN_PROMOS(state, payload) {
    state.unseenPromos = payload
  },
  SET_LOADING(state, { key, value }) {
    state.loading[key] = value;
  }
};

const actions = {
  async login({ commit, dispatch }, payload) {
    commit({ type: "SET_PRELOADER_INCR" }, { root: true });
    commit("SET_ERROR", null);
    let res = await api.user.login(payload);
    if (res.isSuccess) {
      commit("SET_TOKEN", res.result.access_token);
      commit("SET_IS_AUTH", true);
      commit("SET_USER_ID", res.result.user_id);
      commit("SET_USER_ROLE", res.result.promo_group.system_name);
      dispatch("fetchUser");
    } else {
      commit("SET_ERROR", res.error.getMessage());
    }
    commit({ type: "SET_PRELOADER_DECR" }, { root: true });
    return res;
  },
  async register({ commit }, payload) {
    commit({ type: "SET_PRELOADER_INCR" }, { root: true });
    commit("SET_ERROR", null);
    let res = await api.user.register(payload);
    if (!res.isSuccess) {
      if (res.error.value[0].error_lang_alias[0] === "cts.company_service.collision_inn") {
        commit(
          "SET_ERROR",
          "Компания с указанным ИНН уже существует. Если данный ИНН принадлежит Вам, то необходимо обратиться в техническую поддержку bonus@brixogroup.com."
        );
      } else if (
        res.error.value[0].error_lang_alias[0] === "cts.validation.validation_error" &&
        res.error.value[0].error_system_message["field_key"] === "phone"
      ) {
        commit("SET_ERROR", "Телефон должен состоять из 11 цифр.");
      } else if (res.error.value[0].error_lang_alias[0] === "cts.invite_service.invitation_by_system_manager") {
        commit("SET_ERROR", "Регистрация по приглашению от системного участника не допускается.");
      } else if (res.error.value[0].error_lang_alias[0] === "cts.invite_service.relation_to_system_manager") {
        commit("SET_ERROR", "Регистрация с привязкой к системному сейлз менеджеру не допускается.");
      } else {
        commit("SET_ERROR", res.error.getMessage());
      }
    }
    commit({ type: "SET_PRELOADER_DECR" }, { root: true });
    return res;
  },
    async fetchUnseenPromos({ commit }) {
    let res = await api.general.getPromos(1, 8);
    if (res.isSuccess) {
      if (res.result.data && res.result.data.length > 0) {
        commit("SET_UNSEEN_PROMOS", res.result.data[0].count_un_clicked);
      }
    } 
    return res;
  },
  async fetchUser({ commit, dispatch }) {
    commit("SET_SHOW_TERMS", false);

    try {
      const general = await dispatch("fetchUserGeneral");
      if (!general.result.is_agreement_accepted) {
        commit("SET_SHOW_TERMS", true);
      }
      dispatch("fetchUserLimitCurators");
      dispatch("fetchUnseenPromos");
      return { isSuccess: true };
    } catch (e) {
      dispatch("logout");
      return { isSuccess: false };
    }
  },
  async fetchUserGeneral({ commit }) {
    commit("SET_LOADING", { key: "general", value: true });
    try {
      const res = await api.user.getUserProfileGeneral();
      if (res.isSuccess) {
        commit("SET_CURRENT_USER", res.result);
      }
      return res;
    } finally {
      commit("SET_LOADING", { key: "general", value: false });
    }
  },
  async fetchUserBalance({ commit }) {
    commit("SET_LOADING", { key: "balance", value: true });
    const res = await api.user.getUserProfileBalance();
    if (res.isSuccess) {
      commit("SET_USER_BALANCE", res.result.points);
    }
    commit("SET_LOADING", { key: "balance", value: false });
    return  res.result.points;
  },
  async fetchUserDeals({ commit }) {
    commit("SET_LOADING", { key: "deals", value: true });
    try {
      const res = await api.user.getUserProfileDeals();
      if (res.isSuccess) {
        commit("SET_USER_DEALS", res.result.has_approved_deals);
      }
      return res;
    } finally {
      commit("SET_LOADING", { key: "deals", value: false });
    }
  },
  async fetchUserLimitCurators({ commit, state }) {
    commit("SET_LOADING", { key: "limitCurators", value: true });
    try {
      const res = await api.user.getUserProfileLimitCurators();
      if (res.isSuccess) {
        if (state.currentUser) {
          commit("SET_CURRENT_USER", {
            ...state.currentUser,
            related_curators_ids: res.result.related_curators_ids,
            count_curators: res.result.count_curators,
            max_count_curators: res.result.max_count_curators,
            is_allow_add_relations: res.result.is_allow_add_relations
          });
        }
      }
      return res;
    } finally {
      commit("SET_LOADING", { key: "limitCurators", value: false });
    }
  },
  async fetchUserLimitCompanies({ commit }) {
    commit("SET_LOADING", { key: "limitCompanies", value: true });
    try {
      const res = await api.user.getUserProfileLimitCompanies();
      if (res.isSuccess) {
        commit("SET_USER_LIMIT_COMPANIES", res.result);
      }
      return res;
    } finally {
      commit("SET_LOADING", { key: "limitCompanies", value: false });
    }
  },
  async fetchUserCompanies({ state, commit }, payload) {
    if (state.userCompanies[payload.page]) {
      return state.userCompanies[payload.page];
    }
    commit("SET_LOADING", { key: "companies", value: true });
    const res = await api.user.getUserProfileCurrentCompanies(payload.page, payload.perPage);
    if (res.isSuccess) {
      commit("SET_USER_COMPANIES", { page: payload.page, data: res.result });
        if (payload.page === 1) {
            let firstCompany = null;
            if (Array.isArray(res.result.data)) {
                firstCompany = res.result.data[0] ;
            } else if (res.result.data && typeof res.result.data === "object") {
                firstCompany = res.result.data;
            }
            commit("SET_USER_MAIN_COMPANY", firstCompany);
        }
    }
    commit("SET_LOADING", { key: "companies", value: false });
    return res.result;
  },
  async getUserRelations({ commit }) {
    commit("SET_LOADING", { key: "relations", value: true });
    const res = await api.user.getUserProfileRelations();
    if (res.isSuccess) {
      commit("SET_USER_RELATIONS", res.result);
    }
    commit("SET_LOADING", { key: "relations", value: false });
    return res.result;
  },
  async logout({ commit, dispatch }) {
    commit({ type: "SET_PRELOADER_INCR" }, { root: true });
    commit("SET_TOKEN", null);
    commit("SET_IS_AUTH", false);
    commit("SET_USER_ROLE", null);
    commit("SET_CURRENT_USER", null);
    localStorage.clear();
    router.push("/");
    let res = await api.user.logout();
    commit({ type: "SET_PRELOADER_DECR" }, { root: true });
    dispatch("initMainPage", null, { root: true });
    return res;
  },
  resetError({ commit }) {
    commit("SET_ERROR", null);
  },
  openSystemCurator({ commit }, payload) {
    commit("SET_SHOW_SYSTEM_CURATOR", payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
